import React, { useEffect, useState } from "react";
import { urlparams } from "../../config/bootstrap";
import { NavLink } from "react-router-dom";
import { onClickNavLinkMantra } from "../../utils/helper";

const MyMantra = () => {
  const [TickArr, setTettickArr] = useState([]);
  useEffect(() => {
    if (localStorage.getItem("doneMantraArray")) {
      let doneMantraArray = JSON.parse(localStorage.getItem("doneMantraArray"));
      setTettickArr(doneMantraArray);
    }
  }, []);

  return (
    <div className="container">
      <section className="MyMantra_section">
        <div className="pos_rel">
          <img src="/assets/img/mymantra.png" className="mymntra_img" />
          <div className="ico_wrp">
            <NavLink
              to={"/module/" + "mymantra" + "/" + urlparams + "&view="}
              onClick={() =>
                onClickNavLinkMantra("/module/" + "mymantra", {
                  name: "mymantra",
                })
              }
            >
              <img src="/assets/img/upload.png" />
            </NavLink>
          </div>
        </div>
        <div className="mymntra_txt">
          <h6 className="m1_text">My Mantra
            {TickArr.includes("mymantra") && <img src="/assets/img/tick.png" className="tick_img" />}
          </h6>
          <h3 className="m2_text">Share Your Own Mantra</h3>
        </div>
      </section>
    </div>
  );
};
export default MyMantra;
